import React from "react";
import {
  FaArrowUpRightFromSquare,
  FaGavel,
  FaLock,
  FaFileContract,
  FaLayerGroup,
} from "react-icons/fa6";

function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

const appLinks = [
  {
    label: "MonAppliClub",
    href: "https://www.monappliclub-demo.com",
  },
  {
    label: "MonAppliClub Light",
    href: "https://www.monappliclub-demo-light.com",
  },
  {
    label: "MonAppliComité",
    href: "https://www.judogironde.fr/",
  },
  {
    label: "MonAppliLigue",
    href: "https://www.liguejudona.com/",
  },
  {
    label: "MonAppliOmnisport",
    href: "https://www.union-sportive-bouscataise.com/",
  },
  {
    label: "MonAppliMairie",
    href: "https://www.monapplimairie.com/",
  },
  {
    label: "MonAppliTournoi",
    href: "https://www.scoreboard-judo-club.fr/",
  },
  {
    label: "MonAppliKata",
    href: "https://www.monappliclub.com/partenaires-kata",
  },
  {
    label: "Judo Coach Pro",
    href: "https://www.judo-coach-pro.com/",
  },
  {
    label: "Judo Score Pro",
    href: "https://play.google.com/store/apps/details?id=com.victorin.judoscorepro",
  },
];

const legalLinks = [
  {
    label: "Mentions légales",
    href: "/mentions-legales",
    icon: <FaGavel className="text-sm" />,
  },
  {
    label: "Politique de confidentialité",
    href: "/politique-confidentialite",
    icon: <FaLock className="text-sm" />,
  },
  {
    label: "Conditions d’utilisation",
    href: "/conditions-utilisation",
    icon: <FaFileContract className="text-sm" />,
  },
];

const Footer = () => {
  return (
    <footer className="mt-16 overflow-hidden border-t border-slate-200 bg-slate-950 text-white dark:border-slate-800">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="grid gap-8 py-12 lg:grid-cols-[1.05fr_1.35fr_0.85fr]">
          {/* Bloc marque */}
          <div className="rounded-[28px] border border-white/10 bg-white/5 p-6 backdrop-blur-sm">
            <div className="flex flex-col items-center text-center lg:items-start lg:text-left">
              <div className="rounded-[24px] bg-white/10 p-3 ring-1 ring-white/10">
                <img
                  src="/logo_presence-pro3.png"
                  alt="Logo Présence Club Pro"
                  className="h-auto w-[130px] sm:w-[150px]"
                />
              </div>

              <h2 className="mt-4 text-2xl font-black tracking-tight text-white">
                Présence Club Pro
              </h2>

              <p className="mt-3 max-w-md text-sm leading-7 text-white/70">
                Application web pensée pour les clubs sportifs afin de gérer les
                adhérents, les groupes, les lieux et le suivi des présences au
                quotidien.
              </p>

              <div className="mt-5 inline-flex items-center gap-2 rounded-full bg-blue-500/15 px-3 py-1.5 text-xs font-semibold uppercase tracking-wider text-blue-200">
                <FaLayerGroup />
                Écosystème MonAppliClub
              </div>
            </div>
          </div>

          {/* Applications */}
          <div className="rounded-[28px] border border-white/10 bg-white/5 p-6 backdrop-blur-sm">
            <div className="flex items-center gap-3">
              <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-blue-500/15 text-blue-200">
                <FaLayerGroup />
              </div>
              <div>
                <h3 className="text-xl font-black text-white">
                  Mes autres applications
                </h3>
                <p className="text-sm text-white/60">
                  Découvrez les autres solutions de l’écosystème.
                </p>
              </div>
            </div>

            <nav className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {appLinks.map((app) => (
                <a
                  key={app.label}
                  href={app.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={cn(
                    "group flex items-center justify-between gap-3 rounded-2xl border border-white/8 bg-white/5 px-4 py-3 text-sm font-medium text-white/85 transition",
                    "hover:border-blue-400/30 hover:bg-blue-500/10 hover:text-white"
                  )}
                >
                  <span className="min-w-0 truncate">{app.label}</span>
                  <FaArrowUpRightFromSquare className="shrink-0 text-xs text-white/40 transition group-hover:text-blue-200" />
                </a>
              ))}
            </nav>
          </div>

          {/* Liens légaux */}
          <div className="rounded-[28px] border border-white/10 bg-white/5 p-6 backdrop-blur-sm">
            <h3 className="text-xl font-black text-white">Informations</h3>
            <p className="mt-2 text-sm text-white/60">
              Retrouvez ici les informations légales importantes.
            </p>

            <nav className="mt-6 flex flex-col gap-3">
              {legalLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className={cn(
                    "group flex items-center gap-3 rounded-2xl border border-white/8 bg-white/5 px-4 py-3 text-sm font-medium text-white/85 transition",
                    "hover:border-blue-400/30 hover:bg-blue-500/10 hover:text-white"
                  )}
                >
                  <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-white/10 text-white/70 transition group-hover:bg-blue-500/20 group-hover:text-blue-200">
                    {link.icon}
                  </span>
                  <span>{link.label}</span>
                </a>
              ))}
            </nav>
          </div>
        </div>
      </div>

      {/* Barre du bas */}
      <div className="border-t border-white/10 bg-black/40">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-4 text-center text-sm text-white/70 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:text-left">
          <p>
            © {new Date().getFullYear()} Présence Club Pro — Tous droits réservés.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 lg:justify-end">
            <span>Propulsé par</span>
            <a
              href="https://www.monappliclub.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-white transition hover:text-blue-300"
            >
              MonAppliClub
            </a>
            <span>·</span>
            <a
              href="https://profile.vkard.io/8f8e4d95-cf28-40b0-afc6-2ec677889d49/ab099714aa"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-white transition hover:text-blue-300"
            >
              Laurent VICTORIN
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;